import { axios } from "../../lib";

export const changePassword = ({id, oldPassword, newPassword}) => {
    return axios.put('/auth/password', {id, oldPassword, newPassword})
}